import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotFound = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 176,
	height: 214,
	viewBox: "0 0 176 214",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M142.857 24H33.1429C28.0934 24 24 28.0934 24 33.1429V180.082C24 185.131 28.0934 189.224 33.1429 189.224H142.857C147.907 189.224 152 185.131 152 180.082V33.1429C152 28.0934 147.907 24 142.857 24Z",
			fill: "white",
			stroke: "#DADDE3",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M133.388 37.3877H42.6122C40.4482 37.3877 38.6939 39.142 38.6939 41.3061V42.6122C38.6939 44.7762 40.4482 46.5306 42.6122 46.5306H133.388C135.552 46.5306 137.306 44.7762 137.306 42.6122V41.3061C137.306 39.142 135.552 37.3877 133.388 37.3877Z",
			fill: "#EEF1F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.4286 52.4082H41.9592C40.1558 52.4082 38.6939 53.8701 38.6939 55.6735V56.3266C38.6939 58.1299 40.1558 59.5919 41.9592 59.5919H99.4286C101.232 59.5919 102.694 58.1299 102.694 56.3266V55.6735C102.694 53.8701 101.232 52.4082 99.4286 52.4082Z",
			fill: "#EEF1F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.449 143.184C99.4007 143.184 113.143 129.442 113.143 112.49C113.143 95.538 99.4007 81.7959 82.449 81.7959C65.4972 81.7959 51.7551 95.538 51.7551 112.49C51.7551 129.442 65.4972 143.184 82.449 143.184Z",
			stroke: "#E3E6EB",
			strokeWidth: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.49 87.6572C96.8641 85.0236 92.7058 83.2158 88.3069 82.3608",
			stroke: "#D1A64A",
			strokeWidth: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.778 82.2628C83.0523 81.4297 78.1971 81.7161 73.6022 83.0991C69.0072 84.4822 64.8006 86.9232 61.3199 90.2264C57.8393 93.5296 55.1815 97.6028 53.5601 102.119C51.9387 106.635 51.3988 111.469 51.9837 116.232",
			stroke: "#3B6AB0",
			strokeWidth: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117 151C128.046 151 137 142.046 137 131C137 119.954 128.046 111 117 111C105.954 111 97 119.954 97 131C97 142.046 105.954 151 117 151Z",
			fill: "white",
			stroke: "#3B6AB0",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117 147C125.837 147 133 139.837 133 131C133 122.163 125.837 115 117 115C108.163 115 101 122.163 101 131C101 139.837 108.163 147 117 147Z",
			fill: "#DDEBFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.827 135.954C114.549 135.878 114.346 135.74 114.219 135.539C114.095 135.323 114.092 135.032 114.209 134.666C114.536 133.71 115.004 132.909 115.612 132.263C116.22 131.616 117.124 130.951 118.323 130.267C119.439 129.644 120.272 129.084 120.823 128.587C121.373 128.091 121.737 127.518 121.914 126.87C122.205 125.805 121.757 125.11 120.568 124.785C119.858 124.591 119.274 124.606 118.815 124.828C118.36 125.036 118.067 125.379 117.936 125.857L117.7 126.813C117.628 127.075 117.465 127.279 117.209 127.425C116.973 127.559 116.647 127.57 116.23 127.456C115.752 127.325 115.42 127.085 115.233 126.735C115.066 126.374 115.055 125.932 115.198 125.407C115.409 124.635 115.787 123.984 116.33 123.452C116.893 122.909 117.613 122.551 118.49 122.376C119.368 122.201 120.369 122.268 121.496 122.576C123.024 122.994 124.114 123.648 124.766 124.54C125.437 125.42 125.604 126.478 125.267 127.712C125.001 128.685 124.513 129.497 123.804 130.149C123.095 130.801 122.131 131.416 120.911 131.995C119.883 132.477 119.092 132.883 118.538 133.212C117.983 133.542 117.559 133.849 117.266 134.133C116.992 134.407 116.734 134.743 116.492 135.141C116.275 135.513 116.015 135.765 115.713 135.898C115.431 136.02 115.135 136.039 114.827 135.954ZM112.434 141.247C111.755 141.061 111.288 140.734 111.035 140.267C110.797 139.804 110.76 139.271 110.924 138.669C111.114 137.975 111.459 137.472 111.959 137.161C112.474 136.854 113.087 136.797 113.797 136.991C114.476 137.177 114.939 137.486 115.185 137.919C115.452 138.34 115.496 138.874 115.319 139.523C115.125 140.233 114.768 140.749 114.249 141.071C113.733 141.378 113.128 141.437 112.434 141.247Z",
			fill: "#3B6AB0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.276 147.781C127.785 146.711 126.381 148.166 124.906 148.843C123.431 149.521 121.744 149.16 122.235 150.23L132.021 171.382C132.512 172.452 134.106 172.771 135.581 172.094C137.056 171.416 137.854 170 137.363 168.93L128.276 147.781Z",
			fill: "#3B6AB0"
		})
	]
});
export default SvgNotFound;
